import { BiArrowBack } from 'react-icons/bi'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import CompanyDetails from './company_view_details/CompanyDetails'
import AgentDetails from './company_view_details/AgentTable'
import classNames from 'classnames'
import OAppointments from 'components/reusable/OAppointments'
import OPropertyListing from 'components/reusable/OPropertyListing'
import AuthContext from 'context/AuthContext'

const tabBtnClass =
  'ml-3 inline-block py-3 px-2 text-md xl:text-sm font-semibold border-b-2'
const tabActiveClass = 'border-lime-500 text-lime-500'
const tabBorderNoneClass = 'border-transparent'
const TAB_COMPANY_DETAIL = 'company_details'
const TAB_AGENT_DETAIL = 'agent_detail'
const TAB_APPOINTMENT_DETAIL = 'appointment_detail'
export const TAB_PROPERTY_DETAILS = 'property_details'

function CompanyViewPage () {
  const { tab, setTab } = useContext(AuthContext)
  const [viewShow, setViewShow] = useState(false)
  const [defaultTab, setDefaultTab] = useState('company_details')
  const handleTabClick = (action, e) => {
    setDefaultTab(action)
    if (action === TAB_AGENT_DETAIL) setViewShow(false)
  }
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const [item] = useState(location?.state?.item)
  useEffect(() => {
    setTab('')
    if (tab) {
      setDefaultTab(tab)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <div className='p-10 py-2 pt-4'>
        <div className='flex border-b mb-4'>
          <div
            className='flex  items-center cursor-pointer'
            onClick={() => {
              if (viewShow) {
                setViewShow(false)
              } else {
                navigate(-1)
                setTab('')
              }
            }}
          >
            <BiArrowBack className='h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer mb-2' />
            <span className='ml-2'>{t('O_BACK')}</span>
          </div>
          <div className=''>
            <ul className='flex'>
              <li className='mr-0 xl:mr-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_COMPANY_DETAIL)}
                  className={classNames({
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_COMPANY_DETAIL,
                    [tabBorderNoneClass]: defaultTab !== TAB_COMPANY_DETAIL
                  })}
                >
                  {t('O_COMPANY_DETAILS')}
                </button>
              </li>
              <li className='mx-0 xl:mx-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_AGENT_DETAIL)}
                  className={classNames({
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_AGENT_DETAIL,
                    [tabBorderNoneClass]: defaultTab !== TAB_AGENT_DETAIL
                  })}
                >
                  {t('O_AGENT_DETAILS')}
                </button>
              </li>
              <li className='mx-0 xl:mx-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_APPOINTMENT_DETAIL)}
                  className={classNames({
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_APPOINTMENT_DETAIL,
                    [tabBorderNoneClass]: defaultTab !== TAB_APPOINTMENT_DETAIL
                  })}
                >
                  {t('O_APPOINTMENT_DETAILS')}
                </button>
              </li>
              <li className='mx-0 xl:mx-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_PROPERTY_DETAILS)}
                  className={classNames({
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_PROPERTY_DETAILS,
                    [tabBorderNoneClass]: defaultTab !== TAB_PROPERTY_DETAILS
                  })}
                >
                  {t('O_PROPERTY_DETAILS')}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {defaultTab === TAB_COMPANY_DETAIL && <CompanyDetails item={item} />}
      {defaultTab === TAB_AGENT_DETAIL && (
        <AgentDetails
          companyId={item?._id}
          viewShow={viewShow}
          setViewShow={setViewShow}
        />
      )}
      {defaultTab === TAB_APPOINTMENT_DETAIL && (
        <OAppointments companyId={item?._id} />
      )}
      {defaultTab === TAB_PROPERTY_DETAILS && (
        <OPropertyListing companyId={item?._id} />
      )}
    </>
  )
}

export default CompanyViewPage
